// extracted by mini-css-extract-plugin
module.exports = {"button":"_2260_hONoEdIw0fQn-i-dd","icon":"_2jqRTsjshNQfWIFaXE9if0"};